// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nav--PCkzM {\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5em;\n  padding: 0.5em;\n  padding-top: 1em;\n}", "",{"version":3,"sources":["webpack://./src/gui/SmartComponents/Proposal/Navigation/index.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".nav {\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5em;\n  padding: 0.5em;\n  padding-top: 1em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav": "nav--PCkzM"
};
export default ___CSS_LOADER_EXPORT___;
